module.exports = __webpack_public_path__ + "img/HauntedHouseForeground.02de670a.png";